const isMobile = window.innerWidth < 991; // Check if window width is less than 991px
if (window.location.href.includes('watsons.sa/ar')) {
    var placeholderText = isMobile ? "البحث" : "البحث عن منتجات، علامات تجارية والمزيد";
} else {
    var placeholderText = isMobile ? "Search" : "Search for products, brands & more";
}

(async function(algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  const autocomplete = algolia.externals.autocomplete;

  const index_suffix = await algolia.config.index_suffix;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  if (algolia.config.dynamic_selector) {
    const search_url = algolia?.shopify?.routes?.search_url || `${window.Shopify.routes.root}/search`;
    const default_form_search = `form[action="${search_url}"]`;
    algolia.config.input_selector += `, ${default_form_search}`;
  }
  
  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach(container => {
    container.innerHTML = '';
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin } = algolia;
  const plugins = [
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
  ];

  // -------------------------------------------------------------------
  // Debounce autocomplete plugin searches.
  // The Autocomplete widget fires one search per plugin per keystroke
  // with no built-in debounce. This wrapper delays getSources by 350ms
  // so rapid typing only produces 1 search request per idle pause.
  // Each plugin gets its own debounced timer. Because all timers share
  // the same delay they fire in the same tick, allowing the Algolia
  // client to batch all plugin queries into a single HTTP call.
  // -------------------------------------------------------------------
  function debounceGetSources(fn, delay) {
    var timerId;
    return function debouncedGetSources() {
      var args = arguments;
      var ctx = this;
      if (timerId) clearTimeout(timerId);
      return new Promise(function (resolve) {
        timerId = setTimeout(function () {
          resolve(fn.apply(ctx, args));
        }, delay);
      });
    };
  }

  var AUTOCOMPLETE_DEBOUNCE_MS = 350;

  // Wrap each plugin that exposes getSources at the top level
  var debouncedPlugins = plugins.filter(Boolean).map(function (plugin) {
    if (plugin && typeof plugin.getSources === 'function') {
      return Object.assign({}, plugin, {
        getSources: debounceGetSources(plugin.getSources.bind(plugin), AUTOCOMPLETE_DEBOUNCE_MS)
      });
    }
    return plugin;
  });

  //const cssFile = document.getElementById('template_algolia_autocomplete.css');
  //Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  //Link CSS
  //algolia.appendStyle(cssFile.text);
  const autocompleteOptions = {
    openOnFocus: false,
    initialState: {
      query: new URLSearchParams(window.location.search).get("q")
    },
    placeholder: placeholderText,
    detachedMediaQuery: 'none',
    debug: algolia.config.autocomplete_debug,
    insights: false,
    plugins: debouncedPlugins,
    render({ elements, render, html, state }, root) {
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
              .filter(
                      ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
              )
              .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
      render(
              hasLeftPanelResults ?
              algolia.mainTemplate({ html, state }, elements, displaySuggestions)
              : algolia.mainProductsTemplate({ html, state }, elements),
              root
      );
    },
    renderNoResults({ render, html, state }, root) {
      render(
              algolia.noResultsTemplate({ html, state }),
              root
      )
    },
    // onSubmit({ state }) {
    //   window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
    // }
  }


  
  containers.forEach(container => {
    autocomplete({
      container,
      ...autocompleteOptions
    });
  });
})(window.algoliaShopify);
let algoliaClickListenerBound = false;
function wrapper_track_addtocart_buttons(){
    // track_addtocart_buttons() used to re-scan and bind a listener per
    // button on every render. It's gone (algolia_instant_search_product.liquid
    // now uses a single delegated document click listener that covers every
    // card, including ones added later by pagination), so calling it here
    // would just throw - this wrapper only needs its other per-render work now.
    promo_call();
    if (window.location.pathname.includes('/collections/') && !algoliaClickListenerBound){
        document.addEventListener('click', function (e) {          
          const hitItem = e.target.closest('.ais-InfiniteHits-item');       
          if (!hitItem) return; // Not inside a product card

          // Find the product title link with objectID inside this hit item
          const productLink = hitItem.querySelector('.ais-hit--title a[data-algolia-objectid]');
          if (!productLink) return;         

          // Check if the clicked element is the productLink itself (or inside it)
          if (e.target.closest('.ais-hit--title a[data-algolia-objectid]')) {            
            const objectID = productLink.dataset.algoliaObjectid;
            const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';  
            const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
            const locale = window.Shopify.locale || 'en';
            let indexName;
            if (locale === 'ar') {
              indexName = 'shopify_products_saudi_arabia_ar';
            } else {               
              indexName = `${window.algoliaShopify.config.index_prefix}products`;
            }
            aa('clickedObjectIDs', {             
              userToken: userToken,
              authenticatedUserToken: authenticatedUserToken,
              eventName: 'clickedObjectIDs',
              index: window.algoliaShopify.dynamicIndexName || indexName,
              objectIDs: [objectID]
            });
          }
          
        });
        algoliaClickListenerBound = true;
    }
}


function promo_call() {
  if(window.innerWidth > 991){
    var allpromo_calls = document.querySelectorAll(".promo_call");
    if(allpromo_calls.length > 0){
      for (var i = 0; i < allpromo_calls.length; i += 5) {
        // Check if there are five consecutive empty .promo_call elements
        if (!allpromo_calls[i].textContent.trim() &&
            !allpromo_calls[i + 1].textContent.trim() &&
            !allpromo_calls[i + 2].textContent.trim() &&
            !allpromo_calls[i + 3].textContent.trim() &&
            !allpromo_calls[i + 4].textContent.trim()) {
          // Hide the five consecutive empty .promo_call elements
          allpromo_calls[i].closest(".ais-InfiniteHits-item").classList.add("non-promo");
          allpromo_calls[i + 1].closest(".ais-InfiniteHits-item").classList.add("non-promo");
          allpromo_calls[i + 2].closest(".ais-InfiniteHits-item").classList.add("non-promo");
          allpromo_calls[i + 3].closest(".ais-InfiniteHits-item").classList.add("non-promo");
          allpromo_calls[i + 4].closest(".ais-InfiniteHits-item").classList.add("non-promo");
        }
      }
    }else{
      document.querySelectorAll(".ais-InfiniteHits-item").forEach((item) => {item.classList.add("non-promo")});
    }
  }
}

